/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clipboard_Copy_SuccessInputs */

const es_clipboard_copy_success = /** @type {(inputs: Clipboard_Copy_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado al portapapeles`)
};

const en_clipboard_copy_success = /** @type {(inputs: Clipboard_Copy_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Clipboard_Copy_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_success = /** @type {((inputs?: Clipboard_Copy_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_clipboard_copy_success(inputs)
	return en_clipboard_copy_success(inputs)
});
export { clipboard_copy_success as "clipboard.copy_success" }